// @ts-nocheck
import * as types from '../../mutation-types';
import listingUtils from '@/app/utils/listing-utils';
import actions from './actions';

const defaultState = () => ({
  id: '',
  newHousingId: '',
  modified: '',
  pricing: null,
  housing: null,
  building: null,
  baseInfo: null,
  renovation: null,
  condominium: null,
  site: null,
  rentedInfo: null,
  realEstate: null,
  municipal: null,
  businessPremise: null,
  agency: null,
  assets: null,
  newHousingInfo: null,
  fullAddress: '',
  suggestedListings: [],
  listingDemographics: null,
  loadingListing: false,
  commission: null,
});

const state = defaultState();

const mutations = {
  [types.SET_LISTING](state, listing) {
    // reset state
    state = Object.assign(state, defaultState());
    if (listing.baseInfo && listing.baseInfo.location) {
      state.fullAddress = getFullAddress(listing.baseInfo.location);
    }

    state = Object.assign(state, listing);
  },
  [types.RESET_LISTING_ASSETS](state) {
    if (state.assets) {
      state.assets = {};
    }
  },
  [types.SET_LISTING_SUGGESTIONS](state, suggestions) {
    state.suggestedListings = suggestions || [];
  },
  [types.SET_LOADING_LISTING](state, isLoading) {
    state.loadingListing = isLoading;
  },
  [types.SET_LISTING_DEMOGRAPHICS](state, demographics) {
    state.listingDemographics = demographics || null;
  },
};

const getters = {
  listingData: (state) => ({
    id: state.id,
    modified: state.modified,
    source: state.source,
    newHousingId: state.newHousingId,
    commission: state.commission,
  }),
  getBaseInfo: (state) => state.baseInfo,
  getListingType: (state) => {
    const listingTypeId = state.baseInfo && state.baseInfo.listingType;
    return listingUtils.getListingTypeById(listingTypeId);
  },
  getPricing: (state) => state.pricing,
  getHousing: (state) => state.housing,
  getBuilding: (state) => state.building,
  getRenovation: (state) => state.renovation,
  getCondominium: (state) => state.condominium,
  getPlanningInformation: (state) => {
    if (state.site && (state.site.planInformation || state.site.planSituation)) {
      const situation = state.site.planSituation || '';
      const info = state.site.planInformation || '';

      let planningInfo = situation;
      planningInfo += situation && info ? ' ' : '';
      planningInfo += info;
      return planningInfo;
    }
    return null;
  },
  getSite: (state) => state.site,
  getRealEstate: (state) => state.realEstate,
  getMunicipal: (state) => state.municipal,
  getRentedInfo: (state) => state.rentedInfo,
  getBusinessPremise: (state) => state.businessPremise,
  getAgency: (state) => state.agency,
  getAssets: (state) => state.assets,
  getNewHousingInfo: (state) => state.newHousingInfo,
  isNewHousing: (state) => state.newHousingInfo && state.newHousingId === state.id,
  fullAddress: (state) => state.fullAddress,
  getBrochure: (state) => {
    let brochure = undefined;
    if (state.assets && state.assets.links) {
      brochure = state.assets.links.find((link) => link.linkType === 'electronicBrochure');
    }
    return !!brochure;
  },
  getMainImage: (state) => {
    if (state.assets && state.assets.mainPicture) {
      return state.assets.mainPicture;
    }
    if (state.assets && state.assets.pictures) {
      const mainPicAsset = _.find(state.assets.pictures, { subType: 'mainPicture' });
      return mainPicAsset ? mainPicAsset.url : null;
    }
    return null;
  },
  getVirtualPresentation: (state) => {
    if (state.assets && state.assets.links) {
      const vrLink = state.assets.links.find((link) => link.linkType === 'virtualPresentation');
      return vrLink && vrLink.url.indexOf('matterport') !== -1 ? vrLink : null;
    }
    return null;
  },
  hasImages: (state) => state.assets && state.assets.pictures && state.assets.pictures.length > 0,
  getImagesWithoutBlueprint: (state) => {
    if (state.assets && state.assets.pictures) {
      return _.filter(state.assets.pictures, (picture) => picture.subType !== 'layoutPicture');
    }
    return null;
  },
  hasBlueprintPicture: (state) => {
    if (state.assets) {
      return !!_.find(state.assets.pictures, { subType: 'layoutPicture' });
    }
    return false;
  },
  getBlueprintPicture: (state) => {
    if (state.assets) {
      return _.find(state.assets.pictures, { subType: 'layoutPicture' });
    }
    return null;
  },
  getImages: (state, getters) => {
    if (state.assets && state.assets.pictures) {
      // Make copy so we don't change the actual array
      const imagesList = getters.getImagesWithoutBlueprint.slice(0);
      const bluePrintPicture = getters.getBlueprintPicture;
      const virtualPresentation = getters.getVirtualPresentation;

      // Virtual presentation as second picture
      if (virtualPresentation) {
        imagesList.splice(1, 0, virtualPresentation);
      }

      // Blueprint as third picture
      if (bluePrintPicture) {
        imagesList.splice(2, 0, bluePrintPicture);
      }

      return imagesList;
    }
    return [];
  },
  getPrimaryArea: (state) => {
    if (state.baseInfo) {
      const listingType = listingUtils.getListingTypeById(state.baseInfo && state.baseInfo.listingType);
      const livingArea = state.housing && state.housing.livingArea;
      const totalArea = state.housing && state.housing.totalArea;
      const siteArea = state.site && state.site.siteArea;
      return listingUtils.getPrimaryAreaWithUnits(listingType, livingArea, totalArea, siteArea);
    }
    return null;
  },
  listingHasCoordinates: (state) =>
    state.baseInfo &&
    state.baseInfo.location &&
    state.baseInfo.location.coordinates &&
    state.baseInfo.location.coordinates.latitude &&
    state.baseInfo.location.coordinates.longitude,
  getSuggestedListings: (state) => state.suggestedListings,
  getNewsecUrl: (state) => {
    if (state.assets && state.assets.links) {
      const applicationLink = state.assets.links.find((link) => link.linkType === 'application');
      return applicationLink ? applicationLink.url : null;
    }
    return null;
  },
  loadingListing: (state) => state.loadingListing,
  getListingDemographics: (state) => state.listingDemographics,
};

const getFullAddress = (location) => {
  let fullAddress = '';
  const street = location.streetAddress.trim();
  const district = location.district;
  const city = location.city;

  if (street) {
    fullAddress += street;
  }

  if (district) {
    fullAddress += street ? `, ${district}` : district;
  }

  if (city) {
    fullAddress += street || district ? `, ${city}` : city;
  }

  return fullAddress;
};

export default {
  state,
  getters,
  mutations,
  actions,
};
